"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const is_overclaim_helper_1 = require("@App/helpers/is-overclaim-helper");
const NakedButton_1 = require("@Components/Buttons/NakedButton");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const BulkRelinquishmentConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup/BulkRelinquishmentConfirmationPopup"));
const OverclaimBulkRelinquishmentControl = () => {
    var _a, _b, _c;
    const { overclaimSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [displayConfirmationPopup, setDisplayConfirmationPopup] = react_1.default.useState(false);
    const worksOnPage = (_b = (_a = overclaimSearchStore.worksRightsHolder) === null || _a === void 0 ? void 0 : _a.works) !== null && _b !== void 0 ? _b : [];
    const enabledWorks = worksOnPage.filter((work) => (0, is_overclaim_helper_1.isOverclaimHelper)(work) && !work.relinquished);
    const isAllSelected = overclaimSearchStore.overclaimsSelectedForBulkAction.size === enabledWorks.length;
    const handleSelectAll = () => {
        if (isAllSelected) {
            overclaimSearchStore.resetOverclaimSelectionForBulkAction();
        }
        else {
            overclaimSearchStore.addMultipleToBulkActionSelection(enabledWorks
                .filter((work) => typeof work.overclaimHeaderId === 'number')
                .map((work) => work.overclaimHeaderId));
        }
    };
    return (react_1.default.createElement("div", { className: 'overclaim-bulk-action-control-wrapper' },
        react_1.default.createElement(ModalPortal_1.default, { isOpen: displayConfirmationPopup },
            react_1.default.createElement(BulkRelinquishmentConfirmationPopup_1.default, { onClose: () => setDisplayConfirmationPopup(false), totalWorks: overclaimSearchStore.overclaimsSelectedForBulkAction.size })),
        overclaimSearchStore.isOverclaimBulkActionStarted ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'bulk-action-instructions' }, "Select all overclaims you wish to relinquish claims on, then click the Relinquish Selected Overclaims\" button."),
            react_1.default.createElement("div", { className: 'bulk-action-control' },
                react_1.default.createElement(NakedButton_1.NakedButton, { "aria-label": "Cancel bulk relinquishment", onClick: () => {
                        overclaimSearchStore.setIsOverclaimBulkActionStarted(false);
                    } }, '< Back'),
                react_1.default.createElement(Button_1.Button, { className: 'select-all', mainColor: false, type: 'primary', onClick: handleSelectAll },
                    react_1.default.createElement(Checkbox_1.default, { id: 'select-all-overclaims', checked: isAllSelected, onClick: handleSelectAll, mainColor: false }),
                    "Select Page (up to 100)"),
                react_1.default.createElement(Button_1.Button, { mainColor: false, type: 'primary', onClick: () => overclaimSearchStore.resetOverclaimSelectionForBulkAction() }, "Clear all selections"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, disabled: overclaimSearchStore.overclaimsSelectedForBulkAction.size === 0, onClick: () => setDisplayConfirmationPopup(true), type: 'primary' }, "Relinquish Selected")),
            react_1.default.createElement("div", { className: 'bulk-selection-count' },
                overclaimSearchStore.overclaimsSelectedForBulkAction.size,
                " of",
                ' ', (_c = overclaimSearchStore.worksRightsHolder) === null || _c === void 0 ? void 0 :
                _c.count,
                " total songs selected for bulk relinquishment"))) : (react_1.default.createElement(Button_1.Button, { className: 'start-bulk-action', mainColor: true, type: 'primary', onClick: () => overclaimSearchStore.setIsOverclaimBulkActionStarted(true) }, "Submit Bulk Relinquishments"))));
};
exports.default = (0, mobx_react_1.observer)(OverclaimBulkRelinquishmentControl);
